import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function AxleCountChips() {
  return (
    <Field
      type="chips"
      name="axleCount"
      options={[
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
        {label: '5', value: '5'},
        {label: '6', value: '6'},
      ]}
      label={i18n.t('entity.vehicle.labels.axleCount')}
    />
  );
}
